import { useState } from 'react'
import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { nextPage } from 'components/RCPro/helpers/nav'
import reactStringReplace from 'react-string-replace'
import api from 'helpers/api'
import Phone from 'components/assets/icons/Phone'
import Envelope from 'components/assets/icons/Envelope'
import Checkbox from 'components/common/Checkbox/Checkbox'
import Arrow from 'components/assets/icons/Arrow'
import Link from 'components/common/Link/Link'
import Button from 'components/common/Button/Button'
import Spinner from 'components/common/Spinner/Spinner'
import ResponseMessage from 'components/common/ResponseMessage/ResponseMessage'
import style from './SignatureChoice.module.scss'

const RCProSignatureChoice = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const { nextPageTransition } = useOutletContext()
  const [ otpType, setOtpType ] = useState(undefined)
  const [ acceptTerms, setAcceptTerms ] = useState(false)
  const { signature, resume, layout } = state.texts
  const [ errorMessage, setErrorMessage ] = useState(false)
  const [ isSpinnerLoading, setIsSpinnerLoading ] = useState(false)

  const { ipid, ni } = resume?.exclusion?.find( codeProduct => codeProduct.name === state.codeProduct ) || {}
  const links = [
    {
      text: signature?.link1,
      url: ni
    },
    {},
    {
      text: signature?.link2,
      url: ipid
    }
  ]

  const options = [
    {
      svg: <Phone />,
      text: signature?.sms,
      name: 'otp_sms'
    },
    {
      svg: <Envelope />,
      text: signature?.mail,
      name: 'otp_email'
    }
  ]

  const submit = async () => {
    try {
      setIsSpinnerLoading(true)
      const { adhesionId, email } = state
      const res = await api.post({
        url: '/subscriptions/sign',
        data: { adhesionId, email, otpType },
        headers: { Authorization: `Bearer ${state.token}` },
      })
      const signatureLink = res?.response?.signatureLink
      if (signatureLink){
        nextPage({ pathname, state, navigate, data: { signatureLink } })
        nextPageTransition()
      } else {
        setErrorMessage(true)
      }
    } catch (error) {
      setErrorMessage(true)
    } finally {
      setIsSpinnerLoading(false);
    }
  }

  return (
    <>
      {isSpinnerLoading && <Spinner />}

      <h1>{signature?.title}</h1>

      {errorMessage && <ResponseMessage className={style.response} label={t('common:form.genericError')} />}

      <ul className={style.choices}>
        {options.map( opt => (
          <li key={`option-${opt.name}`} onClick={() => setOtpType(opt.name)} className={otpType === opt.name ? style.active : undefined}>
            {opt.svg}
            {opt.text}
          </li>
        ) )}
      </ul>

      <Checkbox
        id="agree"
        className={style.checkbox}
        label={
          reactStringReplace(signature?.legalterms, '{{link}}', (match, i) => (
            <Link
              key={`link-${i}`}
              label={links[i-1]?.text}
              target='_blank'
              to={links[i-1]?.url}
            />
          ))
        }
        onChange={() => setAcceptTerms(!acceptTerms)}
      />

      <Button
        label={<>{layout?.next} <Arrow /></>}
        onClick={submit}
        disabled={!otpType || !acceptTerms}
        type="primary"
      />
    </>
  )
}

export default RCProSignatureChoice